import * as types from '../actions/assistantAction';
import { ActivityTypes } from '../../containers/Assistant/constants/activity.constants';

const initialState = {
  types: [
    ActivityTypes.TabletActions,
    ActivityTypes.Create,
    ActivityTypes.Delete,
    ActivityTypes.Modify,
    ActivityTypes.Alert,
    ActivityTypes.Error,
    ActivityTypes.Warning,
  ],
  sid: null,
  search: null,
  startDate: null,
  endDate: null,
  timeInterval: null,
  limit: 20,
  page: 0,
  existNext: false,
  activities: [],
  loading: {
    initial: false,
    lazy: false,
  },
};

const assistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ASSISTANT_ACTIVITY_LOADING: {
      return {
        ...state,
        loading: {
          initial: action.payload.initial,
          lazy: action.payload.lazy,
        },
      };
    }
  
    case types.SET_ASSISTANT_ACTIVITY_DATA: {
      return {
        ...state,
        activities: action.payload,
        existNext: action.payload.length === state.limit,
        loading: {
          initial: false,
          lazy: false,
        },
      };
    }
  
    case types.UPDATE_ASSISTANT_ACTIVITY_DATA: {
      const payloadLen = action.payload.length;
      
      return {
        ...state,
        activities: [...state.activities, ...action.payload],
        existNext: Boolean(payloadLen === action.existNextLimit || payloadLen === state.limit),
        loading: {
          initial: false,
          lazy: false,
        },
      };
    }
  
    case types.REMOVE_ASSISTANT_ACTIVITY: {
      return {
        ...state,
        activities: state.activities.filter(item => item.id !== action.payload.id),
      };
    }
  
    case types.ADD_ASSISTANT_ACTIVITY_DATA: {
      return {
        ...state,
        activities: [...action.payload, ...state.activities],
      };
    }

    case types.CHANGE_ASSISTANT_VALUE: {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    }

    case types.CHANGE_ASSISTANT_SEVERAL_VALUES: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case types.RESET_ASSISTANT_STORE: {
      return {
        ...initialState,
      };
    }

    default: {
      return state;
    }
  }
}

export default assistantReducer;